export const GOTIVA_UID = 'qP2XioUIRxU876I2dPYL8HRNuQz2';
